import React, {useState} from "react";

import {Panel, SidePanels} from "@churchofjesuschrist/eden-side-panels";
import { Stack } from "@churchofjesuschrist/eden-stack";
import styled from "styled-components";

import LoadingModal from "../../../generic/loading/loading-modal/loading-modal";
import useManagedStrings from "../../../utils/use-managed-strings";
import AccordionNavigation from "../../accordion-navigation/accordion-navigation";
import EmployeeIdSearch from "../../employee-id-search/employee-id-search";
import ImpersonationStatus from "../../impersonation-status/impersonation-status";
import ProgramNumberSearch from "../../program-number-search/program-number-search";
import ProgramTreeNavigation from "../../program-tree-navigation/program-tree-navigation";
import TopBar from "../../top-bar/top-bar";
import UserOptions from "../../user-options/user-options";
import LeftMenuHolder from "../left-menu-holder";
import {
  ChildrenHolder,
  FullHeight,
  LightFillContainer,
  RelativeDiv,
  RightColumn,
  UserOptionsHolder,
  leftColumnGrey
} from "../styled-components";



const defaultObj = {};
const defaultFunc = () => {};

const StyledPanel = styled(Panel)`
background-color:${leftColumnGrey};
`
const Desktop = ({
  isWide = false,
  lean = false,
  menuOpen = false,
  topBarProps = defaultObj,
  userOptionsProps = defaultObj,
  programTreeProps = defaultObj,
  programSearchProps = defaultObj,
  impersonateProps = defaultObj,
  onMenuClickOff = defaultFunc,
  language = "en",
  navigationStatus,
  //title = "WISE - The Church of Jesus Christ of Latter Day Saints",
  children
}) => {
  const loading = navigationStatus?.saving;
  const {strings} = useManagedStrings([]);
  const {showEmployeeSearch = false} = impersonateProps;
  const {user, hamburgerClick} = topBarProps;
  const [levelFlyout, setLevelFlyout] = useState();
  return (
    <div>
      <FullHeight>
        <LoadingModal
          active={loading}
          data-id="global-loading-modal"
        />
        {lean ? (<>
          <RelativeDiv>
            <TopBar
              {...topBarProps}
            >

              {(closeMenu) => (
                <UserOptionsHolder>
                  <UserOptions
                    language={language}
                    {...userOptionsProps}
                    closeMenu={closeMenu}
                  />
                </UserOptionsHolder>)
              }
            </TopBar>
          </RelativeDiv>
          <LightFillContainer>
            <RightColumn>
              <Stack gapSize="0">
                {showEmployeeSearch ? (
                  <EmployeeIdSearch
                    strings={strings}
                    {...impersonateProps}
                  />
                ) : null}
                <ImpersonationStatus
                  strings={strings}
                  user={user}
                  {...impersonateProps}
                />
                <ChildrenHolder>{children}</ChildrenHolder>
              </Stack>
            </RightColumn>
          </LightFillContainer>

        </>

        ) : (<SidePanels header={

          <RelativeDiv>
            <TopBar
              {...topBarProps}
              lean={menuOpen}
            >{/*Note: lean hides the hamburger which we want if the menu is open */}

              {(closeMenu) => (
                <UserOptionsHolder>
                  <UserOptions
                    language={language}
                    {...userOptionsProps}
                    closeMenu={closeMenu}
                  />
                </UserOptionsHolder>)
              }
            </TopBar>
          </RelativeDiv>
        }
        startPanel={<StyledPanel open={menuOpen}
          preferredMode="dismissible"
          onClose={hamburgerClick}>
          <LeftMenuHolder isWide={isWide} onClickOutside={onMenuClickOff}>
            <div>
              <ProgramTreeNavigation
                strings={strings}
                {...programTreeProps}
                onLevelFlyoutOpened = {setLevelFlyout}
              >
                <ProgramNumberSearch
                  strings={strings}
                  {...programSearchProps}
                />
              </ProgramTreeNavigation>
              <AccordionNavigation/>
            </div>

          </LeftMenuHolder>
        </StyledPanel>
        }>
          <RelativeDiv>
            {menuOpen && React.isValidElement(levelFlyout) ? levelFlyout : null}
            <RightColumn data-id="layout-right-column">
              <Stack gapSize="0">
                {showEmployeeSearch ? (
                  <EmployeeIdSearch
                    strings={strings}
                    {...impersonateProps}
                  />
                ) : null}
                <ImpersonationStatus
                  strings={strings}
                  {...impersonateProps}
                />
                <ChildrenHolder>{children}</ChildrenHolder>
              </Stack>
            </RightColumn>
          </RelativeDiv>
        </SidePanels>)
        }
      </FullHeight>
    </div>)
}
export default Desktop;
